import { $Keys } from 'utility-types';

import { getItem, setItem } from 'utils/localStorage';

export const IDEALIST_NOTIFICATIONS_KEY = 'idealistNotifications';
export type NotificationStatus = 'NEW' | 'DISMISSED' | 'NOT_SET';
export const NOTIFICATIONS = {
  UPLOAD_RESUME: 'UPLOAD_RESUME',
  ORG_ADMIN_ATS_SURVEY_BANNER: 'ORG_ADMIN_ATS_SURVEY_BANNER',
  ORG_ADMIN_USER_DROPDOWN_ATS_CTA: 'ORG_ADMIN_USER_DROPDOWN_ATS_CTA',
  SALARY_SURVEY_CTA: 'SALARY_SURVEY_CTA',
};
export type NotificationKey = $Keys<typeof NOTIFICATIONS>;
export const getNotificationStatus: (
  arg0: NotificationKey
) => NotificationStatus = (name) => {
  const notifications = getItem(IDEALIST_NOTIFICATIONS_KEY) || {};
  const notification = notifications[name];

  if (notification && notification.status) {
    return notification.status;
  }

  return 'NOT_SET';
};
export const setNotificationStatus = (
  name: NotificationKey,
  status: NotificationStatus
) => {
  const notifications = getItem(IDEALIST_NOTIFICATIONS_KEY) || {};
  const currentNotification = notifications[name] || {};
  const newNotification = { ...currentNotification, status };
  return setItem(IDEALIST_NOTIFICATIONS_KEY, {
    ...notifications,
    [name as string]: newNotification,
  });
};
export const dismissNotification = (name: NotificationKey) =>
  setNotificationStatus(name, 'DISMISSED');
export const notificationIsDismissed = (name: NotificationKey) =>
  getNotificationStatus(name) === 'DISMISSED';
